module.exports = wp.plugins;